import React from "react";
import makeTitle from "function/makeTitle.js";
import { SectionTitle } from "components/items";
import historyImage from "image/history.png";
const sectionTitle = [
	{
		text: "HISTORY",
		color: "defualt",
		break: false,
	},
	{
		text: "SINCE 2014",
		color: "main",
		break: true,
	},
];
const listHistory = [
	{
		id: "history-01",
		year: "2014.12",
		text: "사회적기업가 육성사업 4기 우수 창업팀 선정",
	},
	{
		id: "history-02",
		year: "2015.01",
		text: "동구밭 법인 설립",
	},
	{
		id: "history-03",
		year: "2015.04",
		text: "행복나눔재단 임팩트 투자 2기 선정",
	},
	{
		id: "history-04",
		year: "2015.12",
		text: "카이스트 청년창업투자지주 지분 투자 유치",
	},
	{
		id: "history-05",
		year: "2016.03",
		text: "세계 자폐인의 날 보건복지부 장관 표창",
	},
	{
		id: "history-06",
		year: "2016.04",
		text: "SOPOONG 지분 투자 유치",
	},
	{
		id: "history-07",
		year: "2016.05",
		text: "서울시 예비사회적기업 지정",
	},
	{
		id: "history-08",
		year: "2017.07",
		text: "장애인고용공단 표준사업장 인증",
	},
	{
		id: "history-09",
		year: "2017.10",
		text: "좋은비누연구소 올바른 씻을거리 출시",
	},
	{
		id: "history-10",
		year: "2017.12",
		text: "H온드림 오디션 액셀러레이팅 선정",
	},
	{
		id: "history-11",
		year: "2018.04",
		text: "설거지 워싱바 4만개 판매",
	},
	{
		id: "history-12",
		year: "2018.07",
		text: "설거지워싱바SK스토아홈쇼핑런칭",
	},
	{
		id: "history-13",
		year: "2018.08",
		text: "호텔 어메니티 비누 워커힐 납품",
	},
	{
		id: "history-14",
		year: "2018.11",
		text: "사회적기업 인증",
	},
	{
		id: "history-15",
		year: "2019.01",
		text: "동구밭 제2공장 설립",
	},
	{
		id: "history-16",
		year: "2019.08",
		text: "벤처기업 인증",
	},
];
const historyBgStyle = {
	backgroundImage: `url(${historyImage})`,
};
const History = (props) => {
	const drawHistory = () => {
		return listHistory.map((el) => {
			return (
				<li key={el.id}>
					<p className="history-year color-main">{el.year}</p>
					<p className="history-text">{el.text}</p>
				</li>
			);
		});
	};

	return (
		<section className={`History ${props.className}`}>
			<div className="con">
				<div className="wrap-history">
					<div className="section-header">
						<SectionTitle text={makeTitle(sectionTitle)} type="left" />
					</div>
					<div className="section-contents">
						<ul className="wrap-history">{drawHistory()}</ul>
					</div>
				</div>

				<div className="wrap-image" style={historyBgStyle}>
					<p>
						We Make
						<br />
						The World
					</p>
				</div>
			</div>
		</section>
	);
};

export default History;
